var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"item",class:['js-accordion__item', {'is-opened': _vm.isOpened}],style:(_vm.styleObject)},[_c('div',{class:['js-accordion__trigger', _vm.triggerClass],on:{"click":_vm.triggerClickHandler}},[_vm._t("trigger")],2),_vm._v(" "),_c('div',{ref:"content",class:['js-accordion__content', _vm.contentClass]},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }